(() => {
  const SELECTOR = '[data-lw-tof-advertorial]';

  const publishEvent = (name, detail = {}) => {
    window.dispatchEvent(new CustomEvent('lw:landing-interaction', {
      detail: { name, ...detail }
    }));

    if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
      try {
        Shopify.analytics.publish('lw_landing_interaction', { name, ...detail });
      } catch (error) {
        console.warn('Little Worlds landing analytics publish failed', error);
      }
    }
  };

  const getHeaderOffset = () => {
    const header = document.querySelector('.pageheader, .section-header');
    return header ? header.getBoundingClientRect().height + 12 : 12;
  };

  const scrollToTarget = (target) => {
    const offset = getHeaderOffset();
    const top = window.scrollY + target.getBoundingClientRect().top - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  const init = (root) => {
    if (!root || root.dataset.lwReady === 'true') return;
    root.dataset.lwReady = 'true';

    const stickyCta = root.querySelector('[data-lw-sticky-cta]');
    const hero = root.querySelector('[data-lw-hero]');

    if (stickyCta && hero) {
      document.body.classList.add('lw-tof-advertorial-has-sticky');

      const mobileQuery = window.matchMedia('(max-width: 767px)');
      let heroHasPassed = false;

      const syncSticky = () => {
        if (!mobileQuery.matches) {
          stickyCta.classList.remove('is-visible');
          return;
        }

        stickyCta.classList.toggle('is-visible', heroHasPassed);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          const entry = entries[0];
          heroHasPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          syncSticky();
        }, { threshold: 0 });

        observer.observe(hero);
        mobileQuery.addEventListener?.('change', syncSticky);
      } else {
        const updateSticky = () => {
          heroHasPassed = hero.getBoundingClientRect().bottom < 0;
          syncSticky();
        };

        updateSticky();
        document.addEventListener('scroll', updateSticky, { passive: true });
        window.addEventListener('resize', updateSticky);
      }

      syncSticky();
    }

    root.addEventListener('click', (event) => {
      const tracked = event.target.closest('[data-lw-event]');
      if (tracked) {
        publishEvent(tracked.dataset.lwEvent, {
          href: tracked.getAttribute('href') || '',
          text: tracked.textContent.trim()
        });
      }

      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;

      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      const target = root.querySelector(href) || document.querySelector(href);
      if (!target) return;

      event.preventDefault();
      scrollToTarget(target);
    });

    root.querySelectorAll('details[data-lw-faq]').forEach((detail) => {
      const summary = detail.querySelector('summary');
      if (summary) {
        summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
      }

      detail.addEventListener('toggle', () => {
        if (summary) {
          summary.setAttribute('aria-expanded', detail.open ? 'true' : 'false');
        }

        if (!detail.open) return;
        publishEvent(detail.dataset.lwEvent || 'TofFaqOpened', {
          question: detail.querySelector('summary span')?.textContent?.trim() || ''
        });
      });
    });

    root.querySelectorAll('[data-lw-grid-toggle]').forEach((button) => {
      const grid = button.previousElementSibling;
      if (!grid || !grid.hasAttribute('data-lw-collapsible-grid')) return;

      const expandLabel = button.dataset.expandLabel || 'View more';
      const collapseLabel = button.dataset.collapseLabel || 'Show less';

      const syncLabel = () => {
        const expanded = grid.classList.contains('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        button.textContent = expanded ? collapseLabel : expandLabel;
      };

      syncLabel();

      button.addEventListener('click', () => {
        grid.classList.toggle('is-expanded');
        syncLabel();

        publishEvent(grid.classList.contains('is-expanded') ? 'TofGridExpanded' : 'TofGridCollapsed', {
          label: button.textContent.trim()
        });
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      document.querySelectorAll(SELECTOR).forEach(init);
    });
  } else {
    document.querySelectorAll(SELECTOR).forEach(init);
  }
})();
